<template>
  <div style="height: calc(100vh - 60px); background: #F2F2F6;overflow:auto">
         <el-breadcrumb  separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">{{$t("base.index")}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{$t("index.device")}}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/DeviceList' }">{{$t("index.deviceList")}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{$t("index.batchUpdate")}}</el-breadcrumb-item>
        </el-breadcrumb>
   <el-form size="mini" label-width="130px"   ref="versionForm" class="demo-form-inline">
  <el-row>
      <el-col :span="6">
   <el-form-item :label="$t('device.protocol')">
    <el-select
    style="width:100%"
          v-model="where.protocolid"
          size="mini">
            <el-option v-for="p in protocols" :label="p.desc" :value="p.protocolid" :key="p.protocolid"></el-option>
          </el-select>
  </el-form-item>
    </el-col>
    <el-col :span="6">
       <el-form-item prop="version2" :label="$t('device.sofewareVersion')">
        <el-select
    style="width:100%"
          v-model="where.version2"
          size="mini">
            <el-option v-for="p in softvers" :label="p.version2" :value="p.version2" :key="p.version2"></el-option>
          </el-select>
  </el-form-item>
    </el-col>
    <el-col :span="6">
   <el-form-item :label="$t('device.gatewayNo')" prop="no">
    <el-select  remote :remote-method="remoteMethod" style="width:100%" v-model="where.innerid" clearable filterable >
    <el-option
      v-for="item in equipments"
      :key="item.innerid"
      :label="item.no"
      :value="item.innerid">
    </el-option>
  </el-select>
  </el-form-item>
 
    </el-col>
     <el-col :span="6">
   <el-form-item :label="$t('device.deviceNo')" prop="deviceno">
    <el-input v-model="where.deviceno"></el-input>
  </el-form-item>
   </el-col>
  <el-col :span="6">
    <el-form-item :label="$t('base.dealer')" prop="dealername">
      <el-select style="width:100%" v-model="where.dealerid" clearable filterable >
    <el-option
      v-for="item in dealers"
      :key="item.innerid"
      :label="item.name"
      :value="item.innerid">
    </el-option>
  </el-select>
  </el-form-item>
    </el-col>
     <el-col :span="6">
           <el-form-item style="width:100%" :label="$t('base.power')">
    <el-select clearable  style="width:100%" v-model="where.power" >
            <el-option :label="$t('base.on')" :value="1"></el-option>
            <el-option :label="$t('base.off')" :value="0"></el-option>
          </el-select>
  </el-form-item>
      </el-col>
             <el-col :span="6">
              <el-form-item :label="$t('base.city')">
          <el-select style="width:100%" multiple
    collapse-tags v-model="where.citys" clearable filterable >
    <el-option
      v-for="item in cities"
      :key="item"
      :label="item"
      :value="item">
    </el-option>
  </el-select>
      </el-form-item>
      </el-col>
       <el-col :span="6" style="text-align:right">
 <el-form-item label="" >
  <el-button size="small" type="primary" :title="$t('base.search')" @click="searchDevice()">{{$t("base.search")}}</el-button>
      
        <el-button size="small" type="success" :title="$t('device.timingHistory')" icon="el-icon-time" @click="openHistory()"></el-button>
</el-form-item>
      </el-col>
  </el-row>
   <el-divider></el-divider>
</el-form>
        <el-table
          :data="tabledata"
          ref="table"
          stripe
          border
          @selection-change="handleSelectionChange"
          style="margin:0 30px;width: calc(100% - 60px);border-radius: 0.625rem;font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
        >
         <template slot="empty">
                 <div>{{$t('device.noDeviceCanBeUpdated')}}
              </div>
             </template>　
         <el-table-column
          type="selection"
          width="55"></el-table-column>
          <el-table-column
            type="index"
            :label="$t('base.columnIndex')"
          ></el-table-column>
            <el-table-column prop="dealername"  :label="$t('base.dealer')"  > </el-table-column>
             <el-table-column prop="no" :label="$t('device.gatewayNo')" width="200"> </el-table-column>
           <el-table-column prop="deviceno" :label="$t('device.deviceNo')"> </el-table-column>
             <el-table-column prop="doline" :label="$t('device.gatewayOnline')"  width="80">
               <template slot-scope="scope">
                 <span
                :class="scope.row.online === 1 ? color='success' : 'danger'"
                >{{ scope.row.online ? $t('base.online') : $t('base.offline') }}</span>
            </template>
             </el-table-column>
             <el-table-column prop="city" :label="$t('base.city')"  >
             
            </el-table-column>
          <el-table-column prop="model" :label="$t('base.model')"  >
             
             </el-table-column>
         
              <el-table-column prop="power"  :label="$t('device.deviceOnline')"   width="80">
               <template slot-scope="scope">
                 <span>{{ scope.row.power ? $t('base.on') : $t('base.off') }}</span>
            </template>
             </el-table-column>
              <el-table-column prop="version" :label="$t('device.currentVersion')" width="150"> </el-table-column>
          <el-table-column  column-key="opt"
          :label="$t('device.updateProcess')"
             width="200">
              <template slot="header" slot-scope="scope">
        <el-row>
          <el-col :span="24">
             <el-select
          v-model="version"
          size="mini"
          :placeholder="$t('device.chooseOneVersion')">
            <el-option v-for="v in versions" :label="v.version" :value="v.innerid" :key="v.innerid"></el-option>
          </el-select>
          </el-col>
           <el-col style="margin-top:5px"  :span="24">
            <el-dropdown trigger="click" size="mini" split-button type="success" @click="upload()" @command="createTiming">
              {{$t('device.updateChoosen')}}
  <el-dropdown-menu slot="dropdown">
    <el-dropdown-item> {{$t('device.createTiming')}}</el-dropdown-item>
  </el-dropdown-menu>
</el-dropdown>
             <!-- <el-button type="success" size="mini" @click="upload()">选中升级</el-button> -->
           </el-col>
            <!-- <el-col  style="margin-top:5px" :span="12">
             <el-button type="success" size="mini" @click="uploadAll()">一键全部</el-button>
           </el-col> -->
        </el-row>
      </template>
            <template slot-scope="scope">
              <el-progress v-if="scope.row.status==0" :percentage="scope.row.percentage||0"></el-progress>
              <span v-else-if="scope.row.status==1" style="color:green">{{$t('device.updateVersionSuccess')}}</span>
              <span v-else-if="scope.row.status==2" style="color:green">{{$t('device.noNeedUpdateVserion')}}</span>
              <span v-else-if="scope.row.status==3" style="color:red">{{$t('device.updateVersionOffline')}}</span>
              <span v-else-if="scope.row.status==-1" style="color:red">{{$t('device.updateVersionFial')}}</span>
              <span v-else style="color:gray">{{$t('device.notStartVersionUpdate')}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-dialog :title="$t('device.bookTime')" :visible.sync="showTime">
  <el-form>
    <el-form-item :label="$t('device.schUpdateTime')" label-width="300">
      <el-date-picker
      value-format="yyyy-MM-dd HH:mm:ss"
      v-model="plantime"
      type="datetime"
      :placeholder="this.$t('base.choose')">
    </el-date-picker>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="showTime = false">{{$t('base.cancel')}}</el-button>
    <el-button type="primary" @click="saveTimeing()">{{$t('base.confirm')}}</el-button>
  </div>
</el-dialog>
<el-dialog :title="$t('device.bookRecord')" :visible.sync="showHistory">
  <el-table :data="historyData"
  style="font-size:12px"
           :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ 'line-height': '20px', padding: '8px', 'text-align': 'center' }"
  >
    <el-table-column property="version" :label="$t('device.updatedVersion')" ></el-table-column>
    <el-table-column  :label="$t('device.bookDeviceNumber')" >
      <template slot-scope="scope">
                 <span>{{ JSON.parse(scope.row.where).length||0}}</span>
            </template>
    </el-table-column>
    <el-table-column property="createdtime" :label="$t('base.createdtime')" ></el-table-column>
    <el-table-column property="plantime" :label="$t('base.plantime')" ></el-table-column>
    <el-table-column property="runtime" :label="$t('base.runtime')"></el-table-column>
  </el-table>
</el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'UserList',
  data () {
    return {
      where: {type:'heatpump',online:1,protocolid:0},
      tabledata: [],
      equipments:[],
      allEquipments:[],
      historyData:[],
      versions: [],
      softvers:[],
      dealers: [],
      protocols:[],
      version:'',
      multipleSelection:[],
      showTime:false,
      showHistory:false,
      plantime:null
    }
  },
  computed: {
    cities () {
      let citys = Array.from(new Set(this.equipments.filter(e => { return e.city }).map(e => { return e.city })))
      citys.sort((a, b) => {
        return a.localeCompare(b, 'zh')
      })
      return citys
    }
  },
  mounted: function () {
    var self = this
    let customer = window.localStorage.getItem('customer')
    if (customer) {
      customer=JSON.parse(customer)
      this.Common.connentMqtt(this.Common.newGuid())
      Vue.axios
        .post('/equipment/all', {type: 'heatpump', sample: 1})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.allEquipments = res.data.msgbody
            this.equipments = this.allEquipments.slice(0,200);
          } else {
          }
        })
      Vue.axios
        .post('/dealer/all', {})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.dealers = res.data.msgbody
          } else {
          }
        })
        Vue.axios
        .post('/equipment/type/all', {
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.protocols = res.data.msgbody
            self.where.protocolid=self.protocols[0].protocolid
            self.searchDevice()
          } else {
          }
        })
        setTimeout(function(){
          self.Common.mqttReceive(['device/*/devupdateresp'],function(msg){
      
        let obj= JSON.parse(msg.payloadString)
        console.log(obj)
        if(obj.devupdateresp){
           let topic= msg.destinationName.split('/')
          if(topic.length==3){
          let src=topic[1]
          let temp=self.tabledata.filter(d=>{return d.srcaddress==src})
          if(temp&&temp.length>0){
            temp[0].percentage=obj.devupdateresp.progress
            temp[0].status=obj.devupdateresp.status
            // if(obj.devupdateresp.status){
            //   if(obj.devupdateresp.status==1){
            //     temp[0].status=1
            //   }else if(obj.devupdateresp.status==-1){
            //     return '升级失败'
            //   }else if(obj.devupdateresp.status==0){
            //     return '升级中'+row.percentage+'%'
            //   }
            // }else{
            //   return '未开始'
            // }
            self.$forceUpdate()
          }
        }
        }
       
      })
        },1000)
       
          
    } else {
      this.$message({
        message: this.$t("base.noSession"),
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
   
  },
  destroyed:function(){
    this.Common.closeMqtt()
  },
  methods: {
    remoteMethod(query) {
        if (query !== '') {
          // this.loading = true;
          setTimeout(() => {
            // this.loading = false;
           let  temp = this.allEquipments.filter(item => {
              return item.no.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
            this.equipments=temp.slice(0,200)
          }, 200);
        } else {
          this.equipments = this.allEquipments.slice(0,200);
        }
      },
    format(perc){
      if(row.status){
              if(row.status==1){
                return '升级成功'
              }else if(row.status==-1){
                return '升级失败'
              }else if(row.status==2){
                return '已是最新，无需升级'
              }else if(row.status==3){
                return '升级失败，设备离线'
              }else if(row.status==0){
                return '升级中'+row.percentage+'%'
              }
            }else{
              return '未开始'
            }
    },
    createTiming(){
      if (!this.version) {
            this.$message.error(this.$t('device.chooseOneVersion'))
            return
          }
          let version=this.versions.filter(v=>{return v.innerid==this.version})
          if(version.length==0){
            this.$message.error(this.$t('device.chooseOneVersion'))
            return
          }
          if(this.multipleSelection.length==0){
            this.$message.error(this.$t('device.selectOneDevice'))
            return
          }
          let noeVerison=this.multipleSelection.filter(d=>{return d.version2&&version[0].eversionno&&d.version2.toLowerCase()!=version[0].eversionno.toLowerCase()})
          if(noeVerison&&noeVerison.length>0){
            this.$message.error(this.$t('device.deviceNotMatchVersion'))
            return
          }
          this.showTime=true;
    },
    saveTimeing(){
      let self=this
      if(!this.plantime){
        this.$message.error('请选择预约时间')
        return 
      }
      if( new Date(this.plantime)<new Date()){
        this.$message.error('请选择一个将来的时间')
        return 
      }
      Vue.axios
        .post('/equipment/version/timing/add', {
          versionid:this.version,
          plantime:this.plantime,
          where:JSON.stringify(this.multipleSelection.map(d=>{return d.srcaddress}))
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            this.$message({
              showClose: true,
              message:'预约创建成功',
              type: 'success'
            })
            self.plantime=null
            self.showTime=false
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t("base.systemError"),
              type: 'error'
            })
          }
        })
      
    },
    upload () {
      let self = this
      let version=[]
          if (!this.version) {
            this.$message.error(this.$t('device.chooseOneVersion'))
            return
          }
          version=this.versions.filter(v=>{return v.innerid==this.version})
          if(version.length==0){
            this.$message.error(this.$t('device.chooseOneVersion'))
            return
          }
          if(this.multipleSelection.length==0){
            this.$message.error(this.$t('device.selectOneDevice'))
            return
          }
          let noeVerison=this.multipleSelection.filter(d=>{return d.version2&&version[0].eversionno&&d.version2.toLowerCase()!=version[0].eversionno.toLowerCase()})
          if(noeVerison&&noeVerison.length>0){
            this.$message.error(this.$t('device.deviceNotMatchVersion'))
            return
          }
          this.multipleSelection.forEach(d=>{
            self.Common.mqttSend(d.srcaddress,{
                  devupdate: {
          devprotoid : version[0].protocolid,
          url : 'http://116.62.108.68:8000/resource/'+version[0].uuid, //self.version.storage_uri,
          md5 : version[0].md5,
          version : version[0].versionno
      }
            })
          })
          Vue.axios
        .post('/equipment/version/log/add', {versionid:version[0].innerid,srcaddress:this.multipleSelection.map(d=>{return d.srcaddress})})
        .then((res) => {
        })
          
    },
    uploadAll(){
       let version=[]
       if (!this.version) {
            this.$message.error(this.$t('device.chooseOneVersion'))
            return
          }
           version=this.versions.filter(v=>{return v.innerid==this.version})
          if(version.length==0){
            this.$message.error(this.$t('device.chooseOneVersion'))
            return
          }
          this.Common.mqttSend('',{
                  devupdate: {
          devprotoid : version[0].protocolid,
          url :  'http://116.62.108.68:8000/resource/'+version[0].uuid,//self.version.storage_uri,
          md5 : version[0].md5,
          version : version[0].versionno
      }
            },'server/00000000000000000000000000000001/ec600')
    },
    searchDevice () {
      var self = this
      Vue.axios
        .post('/equipment/all', this.where)
        .then((res) => {
          if (res.data.errcode == 0) {
            self.tabledata = res.data.msgbody
            self.version=null
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t("base.systemError"),
              type: 'error'
            })
          }
        })
        Vue.axios
        .post('/equipment/version/list', {protocolid:this.where.protocolid,version2:this.where.version2
        })
        .then((res) => {
          if (res.data.errcode == 0) {
            self.versions = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t("base.systemError"),
              type: 'error'
            })
          }
        })
        Vue.axios
        .post('/equipment/softver/all', {})
        .then((res) => {
          if (res.data.errcode == 0) {
            self.softvers = res.data.msgbody
          } else {
            this.$message({
              showClose: true,
              message: res.data.errmsg || this.$t("base.systemError"),
              type: 'error'
            })
          }
        })
    },
     handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      openHistory(){
        this.historyData=[]
        Vue.axios
        .post('/equipment/version/timing/list', {})
        .then((res) => {
          if (res.data.errcode == 0) {
            this.historyData = res.data.msgbody
          } else {
          }
        })
        this.showHistory=true
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.success{
  color:#67c23a
}

.danger{
  color:red
}

.info{
  color:gray
}
</style>



// WEBPACK FOOTER //
// src/components/Devices/VersionUpload.vue